import { createFileRoute } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';
import { RechargeSeu } from 'pages/recharge-seu';
import { DepositMode } from 'services/recharges/recharges.config';
import { z } from 'zod';

const rechargeSearchSchema = z.object({
  formIdFromUrl: z.string().optional(),
  amount: z.number().optional(),
  promoCode: z.string().optional(),
  method: z.enum(DepositMode).optional(),
  selectBonus: z.string().optional(),
  ['modifica-limiti-ricarica']: z.boolean().optional(),
});

export const Route = createFileRoute('/_auth/topup/')({
  component: RechargeSeu,
  validateSearch: zodValidator(rechargeSearchSchema),
});
